import React from 'react';

import { H2, H5 } from '../../components';

import css from './SectionHowItWorks.module.css';
import { ReactComponent as RequestQuotesSVG } from '../../assets/svg/request-quotes.svg';
import { ReactComponent as SecureYourOrderSVG } from '../../assets/svg/secure-your-order.svg';
import { ReactComponent as ReceiveTailoredQuotesSVG } from '../../assets/svg/receive-tailored-quotes.svg';
import { ReactComponent as ExploreTrustedSuppliersSVG } from '../../assets/svg/explore-trusted-suppliers.svg';
import { FormattedMessage } from 'react-intl';

const SectionHowItWorks = props => {
  return (
    <article className={css.root}>
      <H2 as="h2" className={css.articleHeader}>
        <FormattedMessage id="LandingPage.howItWorks" />
      </H2>
      <p className={css.articlePara}>
        <FormattedMessage id="LandingPage.streamlinJourney" />
      </p>
      <section className={css.gridContainer}>
        <div className={css.container}>
          <ExploreTrustedSuppliersSVG />
          <H5 as="h4">
            <FormattedMessage id="LandingPage.exploreSuppliers" />
          </H5>
          <p>
            <FormattedMessage id="LandingPage.topRatedProviders" />
          </p>
        </div>
        <div className={css.container}>
          <RequestQuotesSVG />
          <H5 as="h4">
            <FormattedMessage id="LandingPage.contactQuote" />
          </H5>
          <p>
            <FormattedMessage id="LandingPage.reachOutForQuote" />
          </p>
        </div>
        <div className={css.container}>
          <ReceiveTailoredQuotesSVG />
          <H5 as="h4">
            <FormattedMessage id="LandingPage.getTailoredQuote" />
          </H5>
          <p>
            <FormattedMessage id="LandingPage.receiveTailoredQuote" />
          </p>
        </div>

        {/* <div className={css.container}>
          <SecureYourOrderSVG />
          <H5 as="h4">Secure Your Order</H5>
          <p>
            Finalize your choice, and we'll ensure prompt and enjoy seamless fast, reliable
            delivery.
          </p>
        </div> */}
      </section>
    </article>
  );
};

export default SectionHowItWorks;
